import { AllStudentRoleIds } from "@/constants/userRoles";
import { RouteRecordRaw } from "vue-router";

export default [
  {
    path: "/student/assignments",
    component: () =>
      import(/* webpackChunkName: 'Assignments' */ "@/views/student/Assignments.vue"),
    name: "Assignments",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/conduct-assignment/:assignmentId",
    component: () =>
      import(/* webpackChunkName: 'ConductAssignment' */ "@/views/student/ConductAssignment.vue"),
    name: "ConductAssignment",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/conduct-test/:testType/:testId",
    component: () =>
      import(/* webpackChunkName: 'ConductTest' */ "@/views/student/ConductTest.vue"),
    name: "ConductTest",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/create-self-test",
    component: () =>
      import(/* webpackChunkName: 'CreateSelfTest' */ "@/views/student/CreateSelfTest.vue"),
    name: "CreateSelfTest",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/institute-tests",
    component: () =>
      import(/* webpackChunkName: 'InstituteTests' */ "@/views/student/InstituteTests.vue"),
    name: "InstituteTests",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/report-subjective-questions",
    component: () =>
      import(
        /* webpackChunkName: 'ReportSubjectiveQuestions' */ "@/views/student/ReportSubjectiveQuestions.vue"
      ),
    name: "ReportSubjectiveQuestions",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/learn-concepts-videos",
    component: () =>
      import(
        /* webpackChunkName: 'LearnConceptsVideos' */ "@/views/student/LearnConceptsVideos.vue"
      ),
    name: "LearnConceptsVideos",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/learn-doubts-revision",
    component: () =>
      import(
        /* webpackChunkName: 'LearnDoubtsRevision' */ "@/views/student/LearnDoubtsRevision.vue"
      ),
    name: "LearnDoubtsRevision",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/live-classes",
    component: () =>
      import(/* webpackChunkName: 'LiveClasses' */ "@/views/student/LiveClasses.vue"),
    name: "LiveClasses",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/live-practice",
    component: () =>
      import(/* webpackChunkName: 'LivePractice' */ "@/views/student/LivePractice.vue"),
    name: "LivePractice",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/past-year-papers",
    component: () =>
      import(/* webpackChunkName: 'PastYearPapers' */ "@/views/student/PastYearPapers.vue"),
    name: "PastYearPapers",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/report-effort-analysis",
    component: () =>
      import(
        /* webpackChunkName: 'ReportEffortAnalysis' */ "@/views/student/ReportEffortAnalysis.vue"
      ),
    name: "ReportEffortAnalysis",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/report-subject-coverage",
    component: () =>
      import(
        /* webpackChunkName: 'ReportSubjectCoverage' */ "@/views/student/ReportSubjectCoverage.vue"
      ),
    name: "ReportSubjectCoverage",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/report-test-performance",
    component: () =>
      import(
        /* webpackChunkName: 'ReportTestPerformance' */ "@/views/student/ReportTestPerformance.vue"
      ),
    name: "ReportTestPerformance",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/self-practice",
    component: () =>
      import(/* webpackChunkName: 'SelfPractice' */ "@/views/student/SelfPractice.vue"),
    name: "SelfPractice",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/conduct-self-practice/:selfPracticeId",
    component: () =>
      import(
        /* webpackChunkName: 'ConductSelfPractice' */ "@/views/student/ConductSelfPractice.vue"
      ),
    name: "ConductSelfPractice",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/self-tests",
    component: () => import(/* webpackChunkName: 'SelfTests' */ "@/views/student/SelfTests.vue"),
    name: "SelfTests",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/dashboard",
    component: () =>
      import(/* webpackChunkName: 'StudentDashboard' */ "@/views/student/StudentDashboard.vue"),
    name: "StudentDashboard",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/student/my-profile",
    component: () =>
      import(/* webpackChunkName: 'StudentProfile' */ "@/views/student/StudentProfile.vue"),
    name: "StudentProfile",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      hideFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
] as unknown as Array<RouteRecordRaw>;
